// import { NotesIcon } from 'assets/icons';

import * as S from './ChartTooltip.styled';

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const ChartTooltip = ({
  day,
  dayData,
  metrics,
  colors,
  selectedMetrics,
  tooltipPlacement,
  currentEventTitle = '',
}) => {
  return (
    <S.TooltipWrap tooltipPlacement={tooltipPlacement}>
      <S.LeftSide>
        <S.Day>{formatDate(day)}</S.Day>
        <table style={{ margin: 'auto' }}>
          <tbody>
            {metrics.map((metric) => (
              <S.MetricWrap
                style={{ display: selectedMetrics[metric] ? 'table-row' : 'none' }}
                key={metric + day}
              >
                <S.Value>{formatValue(dayData[metric], metric)}</S.Value>
                <td>
                  <S.Point color={colors[metric]}></S.Point>
                </td>
                <S.Title>{formatTitles(metric, currentEventTitle)}</S.Title>
              </S.MetricWrap>
            ))}
          </tbody>
        </table>
      </S.LeftSide>
      {/*{dayData?.note && (
        <S.RightSide>
          <NotesIcon />
          <S.NoteText>{dayData?.note}</S.NoteText>
        </S.RightSide>
      )}*/}
    </S.TooltipWrap>
  );
};

function formatValue(value, metric) {
  let formatedMetric = value || 0;

  if (metric === 'impressions' || metric === 'clicks' || metric === 'installs') {
    formatedMetric = formatedMetric.toFixed(0);
  } else {
    formatedMetric = formatedMetric.toFixed(2);
  }

  return +formatedMetric;
}

function formatTitles(metric, eventTitle) {
  let formatedMetric = metric;

  if (metric === 'cr') formatedMetric = 'Conversion Rate';
  if (metric === 'avg_cpi') formatedMetric = 'AVG CPI';
  if (metric === 'avg_cpa') formatedMetric = 'AVG CPA';
  if (metric === 'events') formatedMetric = eventTitle;

  return formatedMetric;
}

function formatDate(inputDate) {
  if (!inputDate) return;

  const date = new Date(inputDate);
  if (!date) return inputDate;

  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();

  return `${day} ${months[month]} ${year}`;
}
